import { useAuthContext } from '../../contexts/AuthContext';
import { useLazyQuery, useMutation, useQuery, useSubscription } from '@apollo/client';
// import { getAgendaUser } from './queries';

import Spinner from 'react-bootstrap/Spinner';
import Carousel from 'react-bootstrap/Carousel';
import { Button, Card, Col, Container, Row, Image, Modal, Stack } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import CustomModal from '../../components/Modals/CustomModal';

function HelpScreen() {
  // AUTH
  const {userId: AuthUserId} = useAuthContext();
  const userId = AuthUserId;
  // I18N
  const { t } = useTranslation();
  // MODAL
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);

  const handleScrollToId = (e: any, id: any) => {
    e.preventDefault(); // Empêche le comportement de défilement par défaut du navigateur
    const element = document.getElementById(id);
    if (element) {
      const yOffset = -100; // Votre décalage pour le header
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.replace('#', '');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          const yOffset = -100; // ajuste selon la hauteur de ton header ou ton H1
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
          // element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 500);
    }

    const scrollOffset = 200;
    const scrollElement = document.querySelector(".js-scroll"); // fading container
    const logoScrollElement = document.querySelector(".slide_logo"); // logo animation

    const elementInView = (el: any, offset = 0) => {
      if (!el) return false;
      const elementTop = el.getBoundingClientRect().top;
      return elementTop <= (window.innerHeight - offset);
    };

    const displayScrollElement = () => scrollElement?.classList.add("scrolled");
    const hideScrollElement = () => scrollElement?.classList.remove("scrolled");
    const handleScrollAnimation = () => {
      if (elementInView(scrollElement, scrollOffset)) {
        displayScrollElement();
      } 
    };

    const displayLogoScrollElement = () => logoScrollElement?.classList.add("scrolled");
    
    const handleLogoAnimation = () => {
      if (elementInView(logoScrollElement, 0)) {
        displayLogoScrollElement();
      }
    };

    const onScroll = () => {
      handleScrollAnimation(); // fading container
      handleLogoAnimation(); // logo animation
    };
    // console.log("logoScrollElement found:", logoScrollElement);

    window.addEventListener("scroll", onScroll);

    // return () => {
    //   window.removeEventListener("scroll", onScroll);
    // };
  const queryString = window.location.search; // Ex: "?missingCompanyLink"
  const query = queryString.substring(1); // Supprime le "?"
  // console.log(query);

  if (query == "missingCompanyLink") {
    setContentModal(<>
      <Modal.Header closeButton>
        <Modal.Title>{t('dashboard.linkedCompanyTitle')}</Modal.Title>
      </Modal.Header>
        
      <Modal.Body>
        <p>{t('dashboard.linkedCompany')}</p>
      </Modal.Body></>);
    // setLinkModal('/');
    setShowCustomModal(true);
  }

  document.title = t('title.help');
}, []);


  // const {data, loading, error, refetch} = useQuery(getAgendaUser, {variables: {userId: userId}});

  // if (loading) {// || loadingShift || loadingRequest) {
  //   return (
  //     <Spinner animation="border" role="status">
  //       <span className="visually-hidden">Loading...</span>
  //     </Spinner>
  //   )
  // };

  
  // const items = [
//     {
//       src: 'https://picsum.photos/id/123/1200/400',
//       altText: 'Slide 1',
//       caption: 'Slide 1',
//       key: 1,
//     },
//     {
//       src: 'https://picsum.photos/id/456/1200/400',
//       altText: 'Slide 2',
//       caption: 'Slide 2',
//       key: 2,
//     },
//     {
//       src: 'https://picsum.photos/id/678/1200/400',
//       altText: 'Slide 3',
//       caption: 'Slide 3',
//       key: 3,
//     },
//   ];
  return (
    <>
      <CustomModal
        show={showCustomModal}
        onHide={() => setShowCustomModal(false)}
        link={linkModal}
        children={contentModal}
        // animation={true}
      />
      <div className="blackTop"><h1>{t('help.title')}</h1></div>
      <Container id="shift_help" fluid className="homeCardContainer">
        <Container className="d-flex flex-column justify-content-center align-items-center" style={{ paddingTop: '20px', marginBottom: '20px', position: 'relative'}}>
          <h2 className="h1 bg_gradient_text" style={{color: '#FFF' }} >{t('help.helpTitle')}</h2>
          <ul className="help_list">
            <li><a href="#create_shift_help" onClick={(e) => handleScrollToId(e, 'create_shift_help')}>{t('help.shiftCreate')}</a> | <a href="#create_shift_mobile_help" onClick={(e) => handleScrollToId(e, 'create_shift_mobile_help')}>( Mobile App )</a></li>
            <li><a href="#create_open_shift_help" onClick={(e) => handleScrollToId(e, 'create_open_shift_help')}>{t('help.openShiftCreate')}</a> | <a href="#create_open_shift_mobile_help" onClick={(e) => handleScrollToId(e, 'create_open_shift_mobile_help')}>( Mobile App )</a></li>
            <li><a href="#transfer_shift_help" onClick={(e) => handleScrollToId(e, 'transfer_shift_help')}>{t('help.transferShift')}</a> | <a href="#transfer_shift_mobile_help" onClick={(e) => handleScrollToId(e, 'transfer_shift_mobile_help')}>( Mobile App )</a></li>
            <li><a href="#paste_spreadsheet_help" onClick={(e) => handleScrollToId(e, 'paste_spreadsheet_help')}>{t('help.pasteSpreadsheet')}</a></li>
            <li><a href="#upload_spreadsheet_help" onClick={(e) => handleScrollToId(e, 'upload_spreadsheet_help')}>{t('help.uploadSpreadsheet')}</a></li>
            <li><a href="#edit_shift_help" onClick={(e) => handleScrollToId(e, 'edit_shift_help')}>{t('help.editShift')}</a></li>
            <li><a href="#delete_shift_help" onClick={(e) => handleScrollToId(e, 'delete_shift_help')}>{t('help.deleteShift')}</a></li>
          </ul>
          <h2 style={{color: '#FFF' }} >{t('help.moreTitle')}</h2>
          <ul className="help_list">
            <li><a href="#clock_in_help" onClick={(e) => handleScrollToId(e, 'clock_in_help')}>{t('help.clockIn')}</a> | <a href="#clock_in_mobile_help" onClick={(e) => handleScrollToId(e, 'clock_in_mobile_help')}>( Mobile App )</a></li>
            <li><a href="#upload_document_help" onClick={(e) => handleScrollToId(e, 'upload_document_help')}>{t('help.uploadDocument')}</a> | <a href="#upload_document_mobile_help" onClick={(e) => handleScrollToId(e, 'upload_document_mobile_help')}>( Mobile App )</a></li>
            <li><a href="#leave_request_help" onClick={(e) => handleScrollToId(e, 'leave_request_help')}>{t('help.leaveRequest')}</a> | <a href="#leave_request_mobile_help" onClick={(e) => handleScrollToId(e, 'leave_request_mobile_help')}>( Mobile App )</a></li>
          </ul>
        </Container>
        <Container className="d-flex flex-column justify-content-center align-items-center" style={{ paddingTop: '20px', marginBottom: '20px', position: 'relative'}}>
          <h2 className="h1" style={{color: '#FFF' }} >{t('help.shiftTitle')}</h2>
          <p style={{color: '#FFF', textAlign: 'center' }}>{t('help.shiftMessage')}</p>
        </Container>

        <Container id="create_shift_help" className="d-flex flex-column justify-content-center align-items-center" style={{ paddingTop: '20px', marginBottom: '20px', position: 'relative'}}>
          <div className="help_video_container">
            <iframe className="help_video" src="https://www.youtube.com/embed/lYwHyB_CnR4" title="Shift Creation" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
          </div>
        </Container>

        <Container id="create_open_shift_help" className="d-flex flex-column justify-content-center align-items-center" style={{ paddingTop: '20px', marginBottom: '20px', position: 'relative'}}>
          <div className="help_video_container">
            <iframe className="help_video" src="https://www.youtube.com/embed/nycVueHlzMg" title="Open Shift (PUBLIC) Creation" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
          </div>
        </Container>

        <Container id="paste_spreadsheet_help"className="d-flex flex-column justify-content-center align-items-center" style={{ paddingTop: '20px', marginBottom: '20px', position: 'relative'}}>
          <div className="help_video_container">
            <iframe className="help_video" src="https://www.youtube.com/embed/SwK0d3XfvlQ" title="Paste shifts from a spreadsheet" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
          </div>
        </Container>

        <Container id="upload_spreadsheet_help"className="d-flex flex-column justify-content-center align-items-center" style={{ paddingTop: '20px', marginBottom: '20px', position: 'relative'}}>
          <div className="help_video_container">
            <iframe className="help_video" src="https://www.youtube.com/embed/UY4db08lyMI" title="Upload spreadsheet or csv to create shifts" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
          </div>
        </Container>

        <Container id="edit_shift_help"className="d-flex flex-column justify-content-center align-items-center" style={{ paddingTop: '20px', marginBottom: '20px', position: 'relative'}}>
          <div className="help_video_container">
            <iframe className="help_video" src="https://www.youtube.com/embed/LcA8zQYTeeA" title="Edit and modify shift" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
          </div>
        </Container>

        <Container id="transfer_shift_help"className="d-flex flex-column justify-content-center align-items-center" style={{ paddingTop: '20px', marginBottom: '20px', position: 'relative'}}>
          <div className="help_video_container">
            <iframe className="help_video" src="https://www.youtube.com/embed/Bw9Gw2QtkHk" title="Transfer shift to another employee" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
          </div>
        </Container>

        <Container id="delete_shift_help" className="d-flex flex-column justify-content-center align-items-center" style={{ paddingTop: '20px', marginBottom: '20px', position: 'relative'}}>
          <div className="help_video_container">
            <iframe className="help_video" src="https://www.youtube.com/embed/c-NhjvjI5o4" title="Delete Shift" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
          </div>
        </Container>

        <Container className="d-flex flex-column justify-content-center align-items-center" style={{ paddingTop: '20px', marginBottom: '20px', position: 'relative'}}>
          <Row>
            <Col id="create_shift_mobile_help" className="d-flex justify-content-center mb-3" style={{justifyContent: 'space-between'}}>
                <div className="help_video_mobile_container">
                    <iframe style={{width: '200px', height: '400px'}} src="https://www.youtube.com/embed/bSpLH7dUN1M" title="Shift Creation (Mobile)" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                </div>
            </Col>
            <Col id="create_open_shift_mobile_help" className="d-flex justify-content-center mb-3">
                <div className="help_video_mobile_container">
                    <iframe style={{width: '200px', height: '400px'}} src="https://www.youtube.com/embed/2qp3g90wN_I" title="Open Shift (PIBLIC) Creation (Mobile)" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                </div>
            </Col>
            <Col id="transfer_shift_mobile_help" className="d-flex justify-content-center mb-3">
                <div className="help_video_mobile_container">
                    <iframe style={{width: '200px', height: '400px'}} src="https://www.youtube.com/embed/ygK9WUXVE-M" title="Transfer shift to another employee (Mobile)" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                </div>
            </Col>
          </Row>
        </Container>

      </Container>
      <Container fluid className="banner-container">
        <div style={{position: 'relative', flex: 'none'}} >
          <div className="waveGapTop"></div>
          <div id="wave-container" >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" style={{ transform: 'scaleY(-1)' }}>
              <path fill="#b0b3f7" fill-opacity="1" d="M0,160L48,160C96,160,192,160,288,176C384,192,480,224,576,218.7C672,213,768,171,864,133.3C960,96,1056,64,1152,48C1248,32,1344,32,1392,32L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z">
              </path>
            </svg>
          </div>
        </div>
        {/* <img src="/home/roundedTopBorder200light.png" alt="Banner" className="curved-bottom-image" style={{marginTop: '-1px'}} /> */}
      </Container>
      {/* { (/iPhone|iPod|Android|BlackBerry|IEMobile/i.test(navigator.userAgent)) ?
        <Container className="d-flex justify-content-center align-items-center" style={{ paddingTop: '20px', marginBottom: '20px', position: 'relative'}}>
          <h1 style={{color: '#BBB' }} >Schedulum</h1>
        </Container>
      :
        <Container className="d-flex justify-content-center align-items-center" style={{marginTop: '-280px', marginBottom: '220px', position: 'relative'}}>
          <h1 style={{color: 'white' }} >Schedulum</h1>
        </Container>
      } */}
      
      {/* { !(/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) && */}
      { (/iPhone|iPod|Android|BlackBerry|IEMobile/i.test(navigator.userAgent)) ?
        <Container className="d-flex justify-content-center align-items-center position-relative">
          {/* <ul className="ai_logo slide_logo js-logo-scroll slide-left"> */}
          <ul className="ai_logo slide_logo js-logo-scroll slide-left d-flex flex-wrap justify-content-center">
              {/* <li><img src="/ai_logo/anthropic.png"/></li>
              <li><img src="/ai_logo/Llama.png"/></li>
              <li><img src="/ai_logo/openai.png"/></li>
              <li><img src="/ai_logo/cohere_black.png"/></li>
              <li><img src="/ai_logo/AI21.png"/></li> */}
              <li><img src="/phones/ios_scheduler_400.png" className="home_phones" alt={t('image.scheduler')} loading="lazy" /></li>
              <li><img src="/phones/ios_agenda_400.png" className="home_phones" alt={t('image.agenda')} loading="lazy" /></li>
              <li><img src="/phones/ios_request_400.png" className="home_phones" alt={t('image.request')} loading="lazy" /></li>
              <li><img src="/phones/ios_leave_400.png" className="home_phones" alt={t('image.leave')} loading="lazy" /></li>
              <li><img src="/phones/ios_post_400.png" className="home_phones" alt={t('image.posts')} loading="lazy" /></li>
          </ul>
        </Container>
      :
        <Container className="d-flex justify-content-center align-items-center position-relative">
          {/* <ul className="ai_logo slide_logo js-logo-scroll slide-left"> */}
          <ul className="ai_logo slide_logo js-logo-scroll slide-left d-flex flex-wrap justify-content-center">
              {/* <li><img src="/ai_logo/anthropic.png"/></li>
              <li><img src="/ai_logo/Llama.png"/></li>
              <li><img src="/ai_logo/openai.png"/></li>
              <li><img src="/ai_logo/cohere_black.png"/></li>
              <li><img src="/ai_logo/AI21.png"/></li> */}
              <li><img src="/phones/ios_scheduler_400.png" className="home_phones" alt={t('image.scheduler')} loading="lazy" /></li>
              <li><img src="/phones/ios_agenda_400.png" className="home_phones" alt={t('image.agenda')} loading="lazy" /></li>
              <li><img src="/phones/ios_request_400.png" className="home_phones" alt={t('image.request')} loading="lazy" /></li>
              <li><img src="/phones/ios_leave_400.png" className="home_phones" alt={t('image.leave')} loading="lazy" /></li>
              <li><img src="/phones/ios_post_400.png" className="home_phones" alt={t('image.posts')} loading="lazy" /></li>
          </ul>
        </Container>
      }

      <Container fluid className="card-container" >
        <div style={{position: 'relative', flex: 'none'}} >
          <div id="wave-container" >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
              <path fill="#b0b3f7" fill-opacity="1" d="M0,160L48,160C96,160,192,160,288,176C384,192,480,224,576,218.7C672,213,768,171,864,133.3C960,96,1056,64,1152,48C1248,32,1344,32,1392,32L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z">
              </path>
            </svg>
          </div>
          <div className="waveGapBottom"></div>
        </div>
        {/* <img src="/home/roundedTopBorder200light.png" alt="Banner" className="curved-top-image" style={{marginBottom: '-1px'}}/> */}

        <Container id="misc_help" fluid className="homeCardContainer">
          <Container className="d-flex flex-column justify-content-center align-items-center" style={{ paddingTop: '20px', marginBottom: '20px', position: 'relative'}}>
            <h2 className="h1" style={{color: '#FFF' }} >{t('help.miscTitle')}</h2>
            <p style={{color: '#FFF', textAlign: 'center' }}>{t('help.miscMessage')}</p>
          </Container>

          <Container id="clock_in_help" className="d-flex flex-column justify-content-center align-items-center" style={{ paddingTop: '20px', marginBottom: '20px', position: 'relative'}}>
            <div className="help_video_container">
              <iframe className="help_video" src="https://www.youtube.com/embed/hrZ-McFzw24" title="Clock In" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            </div>
          </Container>

          <Container id="upload_document_help" className="d-flex flex-column justify-content-center align-items-center" style={{ paddingTop: '20px', marginBottom: '20px', position: 'relative'}}>
            <div className="help_video_container">
              <iframe className="help_video" src="https://www.youtube.com/embed/lsQH4GFRYIE" title="Upload document to an employee" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            </div>
          </Container>

          <Container id="leave_request_help" className="d-flex flex-column justify-content-center align-items-center" style={{ paddingTop: '20px', marginBottom: '20px', position: 'relative'}}>
            <div className="help_video_container">
              <iframe className="help_video" src="https://www.youtube.com/embed/Fpwu8QAy_jM" title="Leave Request" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            </div>
          </Container>

          <Container className="d-flex flex-column justify-content-center align-items-center" style={{ paddingTop: '20px', marginBottom: '20px', position: 'relative'}}>
            <Row>
              <Col id="clock_in_mobile_help" className="d-flex justify-content-center mb-3">
                  <div className="help_video_mobile_container">
                      <iframe style={{width: '200px', height: '400px'}} src="https://www.youtube.com/embed/A08B-VqxhYI" title="Clock In (Mobile)" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                  </div>
              </Col>
              <Col id="upload_document_mobile_help" className="d-flex justify-content-center mb-3">
                  <div className="help_video_mobile_container">
                      <iframe style={{width: '200px', height: '400px'}} src="https://www.youtube.com/embed/FUBTRSVXMOo" title="Upload document to an employee (Mobile)" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                  </div>
              </Col>
              <Col id="leave_request_mobile_help" className="d-flex justify-content-center mb-3">
                  <div className="help_video_mobile_container">
                      <iframe style={{width: '200px', height: '400px'}} src="https://www.youtube.com/embed/bSpLH7dUN1M" title="Transfer shift to another employee (Mobile)" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                  </div>
              </Col>
            </Row>
          </Container>

        </Container>
      </Container>
    </>
   
  );
}

export default HelpScreen;